"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.loading.title': 'Aktywacja Twojego konta',
    'activate.loading.message': 'Poczekaj, podczas gdy aktywujemy Twoje konto...',
};
